import { EventEmitter, Inject, Injectable } from "@angular/core";
import { FormControlStatus, FormGroup, Validators } from "@angular/forms";
import {
  BaseFpxComponentState,
  BaseFpxFormHelper,
  BaseFpxPostSubmitInterceptor,
  CriteriaQuery,
  RoutingInfo,
} from "@fpx/core";
import {
  BaseFpxChangeHandler,
  BaseFpxEventHandler,
  BaseFpxLoadFormHandler,
  FindByKeyFn,
  HttpRequest,
} from "@common/models";
import { Casatransactionfilter } from "./casatransactionfilter.model";
import moment from "moment";
import { API_DATE_FORMAT } from "@common/constants";
import { any } from "@amcharts/amcharts4/.internal/core/utils/Array";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { CasatransactionService } from "../casatransaction-service/casatransaction.service";
import { CASATransactionFilterFormComponent } from "./casa-transaction-filter-form.component";
import { CasatransactionfilterService } from "./casatransactionfilter.service";
import { CommonService } from "src/app/common.service";
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";
import { IPopupScreenData } from "src/app/common/models/popup-screen-data.model";
import { DepositService } from "src/app/deposits/services/deposits.service";

export class CASATransactionFilterFormState extends BaseFpxComponentState {
  showSuggestion: boolean = true;
  showReset: boolean;
  ismonthOrDate: string = "MINISTATEMENT";

  fromMinDate: Date;
  toMinDate: Date;
  maxDate: Date;
}

@Injectable()
export class CASATransactionFilterFormHelper extends BaseFpxFormHelper<CASATransactionFilterFormState> {
  accountNumber: any;
  accountCards:any;
  // constructor() {
  //   super(new CASATransactionFilterFormState());
  // }
  constructor(
    private cASATransactionFilterFormService: CasatransactionfilterService,
    private processService: ProcessShellService,
    private _casaAccountService: AccountsService,
    private _casatransactionService: CasatransactionService,
    private _accountsService: AccountsService,
    private _commonService: CommonService,
    private _fileOpner: FileOpenerService,
    private _matDialogRef: MatDialogRef<CASATransactionFilterFormComponent>,
    private matDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) {
    super(new CASATransactionFilterFormState());
  }


  override doPreInit(): void {
    this.addChangeHandler("transactionPeriod", this.dotransactionPeriodChange);
    this.addChangeHandler("month", this.domonthChange);
    this.addChangeHandler("year", this.doyearChange);
    this.addChangeHandler("from", this.dofromChange);
    this.addChangeHandler("to", this.dotoChange);
    this.addChangeHandler(
      "displayDownloadFormat",
      this.dodisplayDownloadFormatChange
    );


  }
  override doPostInit(): void {
    let data = this._accountsService.popupData;
    this.accountNumber = data.accountNumber;
    this._accountsService.popupData = undefined;
    this.accountCards = this._accountsService.getList().filter((item) => {
        //return item.accountType === "CA" || "SA";
        let currBuzDate=item.curr_buss_date.split('-');
        let today=new Date(Number(currBuzDate[2]),Number(currBuzDate[1])-1,Number(currBuzDate[0]));
      //let today = new Date(currBuzDate[1]+'-'+currBuzDate[0]+'-'+currBuzDate[2]);
      let startDate = moment(today).subtract(12, 'months').format(API_DATE_FORMAT);
        this.state.fromMinDate = new Date(startDate);
        this.state.maxDate = new Date(today);
      })
    

    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.get("transactionPeriod").setValue("0",{eventEmit:false});
    this.formGroup.get("displayDownloadFormat").setValue("1",{eventEmit:false});

    this.formGroup.controls["from"].disable();
    this.formGroup.controls["to"].disable();
    console.log("accountNumberCasa", this.accountNumber);
    
    if(this._accountsService.casaTrxFilterData.length>0){
      let filterData = this._accountsService.casaTrxFilterData.find(x => x.accountNumber === this.accountNumber);
      if(filterData){
        this.formGroup.controls['transactionPeriod'].patchValue(filterData.filterPayload?.transactionPeriod);
        // this.formGroup.patchValue(filterData.filterPayload,{emitEvent:true});
        
        this.formGroup.controls['displayDownloadFormat'].patchValue(filterData.filterPayload?.displayDownloadFormat);

        if(filterData.filterPayload?.transactionPeriod === '1'){
          //temp fix need to change
          this.formGroup.controls['year'].patchValue(filterData.filterPayload.year);
          setTimeout(() => {
            this.formGroup.controls['month'].patchValue(filterData.filterPayload.month);
          }, 300);  
        }else if(filterData.filterPayload.transactionPeriod === '2'){
          //temp fix need to change
          this.formGroup.controls['from'].patchValue(filterData.filterPayload.from);
          setTimeout(() => {
            this.formGroup.controls['to'].patchValue(filterData.filterPayload.to);
          }, 300);
        }
      }
    }
  }

  subtractYears(numOfYears, date = new Date()) {
    date.setFullYear(date.getFullYear() - numOfYears);
    return date;
  }

  private dotransactionPeriodChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE

    // formGroup.controls["dodisplayDownloadFormatChange"].reset("", { emitEvent: false });
    // formGroup.controls["dotransactionPeriodChange"].reset("", { emitEvent: false });

    if (value == "1") {
      this.state.ismonthOrDate = "MONTH";
    } else if (value == "2") {
      this.state.ismonthOrDate = "DATE";
    } else {
      this.state.ismonthOrDate = "MINISTATEMENT";
    }
    formGroup.controls["from"].enable();
    this.setupFormValidation(value[0])
  };

  private doyearChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
    formGroup.controls["from"].reset();
    formGroup.controls["to"].reset();
    formGroup.controls["month"].reset();
  };
  private domonthChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE

  };
 
  private dofromChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Date,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
    if (value) {
      this.state.fromMinDate = this.subtractYears(1);
      value = new Date(value);
      this.state.toMinDate = value;
      formGroup.controls["to"].enable();
      formGroup.controls["to"].reset();
    }
  };
  private dotoChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
  };
  private dodisplayDownloadFormatChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: Array<any>,
    formGroup: FormGroup
  ) => {
    // WRITE CODE HERE TO HANDLE
    // formGroup.controls["dodisplayDownloadFormatChange"].reset("", { emitEvent: false });
    // formGroup.controls["dotransactionPeriodChange"].reset("", { emitEvent: false });
  };

  public override preSubmitInterceptor(payload: Casatransactionfilter): any {
    // WRITE CODE HERE TO HANDLE

     /** Set the casa transaction filter START*/
     let isFilterAlleadyAbl = this._accountsService.casaTrxFilterData.find(x => x.accountNumber===this.accountNumber);
     if(isFilterAlleadyAbl){
      var foundIndex = this._accountsService.casaTrxFilterData.findIndex(x => x.accountNumber===this.accountNumber);
      this._accountsService.casaTrxFilterData[foundIndex] = {accountNumber:this.accountNumber,filterPayload:payload};
     }else{
      this._accountsService.casaTrxFilterData.push({accountNumber:this.accountNumber,filterPayload:payload})
     }

     if(payload.transactionPeriod=="0"){
      const pos = this._accountsService.casaTrxFilterData.findIndex(x => x.accountNumber===this.accountNumber);
      if (pos >= 0){
        this._accountsService.casaTrxFilterData.splice(pos, 1);
      }      
     }
     /** Set the casa transaction filter END*/

    payload.accountNumber = this.accountNumber;
   // payload.fileType = payload.displayDownloadFormat == "2" ? "PDF" : "";
    if (payload.displayDownloadFormat == "2") {
    payload.fileType = "PDF";
  } else if (payload.displayDownloadFormat == "3") { // Assuming '3' is CSV in your HTML
    payload.fileType = "csv";
  } else {
    payload.fileType = "";
  }
    if (payload.transactionPeriod == "1") {
      let s = "01" + "-" + payload.month + "-" + payload.year;
      // let endDate = moment(new Date(Number(payload.year),(Number(payload.month)),1)).subtract(1,'M').endOf('month').format('YYYY-MM-DD');
      // console.log(endDate);
      payload.fromDate = payload.year + "-" + payload.month + "-01";
      payload.toDate = moment(new Date(Number(payload.year), Number(payload.month), 1)).subtract(1, "M").endOf("month").format("YYYY-MM-DD");
    } else if (payload.transactionPeriod == "2") {
      payload.fromDate = payload.from;
      payload.toDate = payload.to;
    } else if (payload.transactionPeriod == "0") {
      let today = new Date();
      // payload.toDate = moment(today).format(API_DATE_FORMAT);
      payload.toDate = this._commonService.serverDate;
      payload.fromDate = moment(today).subtract(6, 'months').format(API_DATE_FORMAT);
    }
    return payload;
  }

  setupFormValidation(value) {
    if (value == '2') {

      this.formGroup.get('month').disable({ emitEvent: false });
      this.formGroup.get('year').disable({ emitEvent: false });
      this.formGroup.get('to').enable({ emitEvent: false });
      this.formGroup.get('from').enable({ emitEvent: false });


      this.formGroup.get('month').removeValidators(Validators.required);
      this.formGroup.get('year').removeValidators(Validators.required);
      this.formGroup.get('to').addValidators(Validators.required);
      this.formGroup.get('from').addValidators(Validators.required);
    } else {
      if (value == '1') {
        this.formGroup.get('month').enable({ emitEvent: false });
        this.formGroup.get('year').enable({ emitEvent: false });
        this.formGroup.get('to').disable({ emitEvent: false });
        this.formGroup.get('from').disable({ emitEvent: false });

        this.formGroup.get('month').addValidators(Validators.required);
        this.formGroup.get('year').addValidators(Validators.required);
        this.formGroup.get('to').removeValidators(Validators.required);
        this.formGroup.get('from').removeValidators(Validators.required);
      } else {
        this.formGroup.get('transactionPeriod').enable({ emitEvent: false });
        // this.formGroup.get('transactionPeriod').addValidators(Validators.required);
        this.formGroup.get('month').removeValidators(Validators.required);
        this.formGroup.get('year').removeValidators(Validators.required);
        this.formGroup.get('to').removeValidators(Validators.required);
        this.formGroup.get('from').removeValidators(Validators.required);
        this.formGroup.get('month').disable({ emitEvent: false });
        this.formGroup.get('year').disable({ emitEvent: false });
        this.formGroup.get('to').disable({ emitEvent: false });
        this.formGroup.get('from').disable({ emitEvent: false });
      }
    }

  }

  public override postSubmitInterceptor(response: any): RoutingInfo {
    let routingInfo: RoutingInfo = new RoutingInfo();
    // WRITE CODE HERE TO HANDLE
    return routingInfo;
  }
  // reset() {
  //   this.formGroup.reset();
  //   this.formGroup.get('transactionPeriod').patchValue('0',{emitEvent : false});
  //   this.formGroup.get('displayDownloadFormat').patchValue('1',{emitEvent : false});
  // }
  submitForm() {
    let payload = this.preSubmitInterceptor(this.formGroup.value);
    if (payload.fileType == "PDF" || payload.fileType == "csv") {
      this.cASATransactionFilterFormService.createFilter(payload).subscribe({
        next: (response: any) => {
          this._commonService.hideSpinner();
          const isPdf = payload.fileType === "PDF";
          const mimeType = isPdf ? "application/pdf" : "text/csv";
          const extension = isPdf ? ".pdf" : ".csv";
          let toDate=payload.toDate.split('-');
          //let toDateObj = new Date(toDate[1]+'-'+toDate[2]+'-'+toDate[0]);
          let toDateObj=new Date(Number(toDate[0]),Number(toDate[1])-1,Number(toDate[2]));
          let toDateSplit= toDateObj.toDateString().split(' ');
          let toDateStr= toDateSplit[2]+"-"+toDateSplit[1]+"-"+toDateSplit[3];

          let accNoStr=payload.accountNumber.substring(payload.accountNumber.length-4,payload.accountNumber.length);
          let fileName="CBP_Statement_"+accNoStr+"_"+toDateStr+extension;

          if (this._commonService.isHybrid()) {
            this._fileOpner.openPDF(
                  response,
                  mimeType,
                  fileName
            );
          } else {
            let documentURL = URL.createObjectURL(
              new Blob([response.body], { type: mimeType })
            );
            const downloadLink = document.createElement("a");
            downloadLink.href = documentURL;
            //const fileName = "TransactionDetails";
            downloadLink.download = fileName;
            downloadLink.click();
            URL.revokeObjectURL(documentURL);
          }
        },error:(error:any)=>{
          this._commonService.hideSpinner();
        },
      });
      this.matDialog.closeAll();
    } else {
      const criteria: CriteriaQuery = new CriteriaQuery();
      criteria.addQueryparam("fromDate", payload.fromDate);
      criteria.addQueryparam("toDate", payload.toDate);
      // criteria.addQueryparam("fileType", "VOS");
      criteria.addQueryparam("accountNumber", payload.accountNumber);
      criteria.addQueryparam("transactionPeriod", payload.transactionPeriod);

       if(payload.transactionPeriod == "0"){
        criteria.addQueryparam("statementType", "miniStatement");
      }else if(payload.transactionPeriod == "1"){
        criteria.addQueryparam("statementType", "monthlyStatement");
      }else if(payload.transactionPeriod == "2"){
        criteria.addQueryparam("statementType", "dateRangeStatement");
      }

      this._accountsService.popupData = { criteria: criteria };
      this.matDialog.closeAll();
    }
  }


  reset() {
    // this.initializeForm();
    this.formGroup.get("transactionPeriod").setValue("0",{eventEmit:false});
    this.formGroup.get("displayDownloadFormat").setValue("1",{eventEmit:false});

    this.formGroup.controls["from"].disable();
    this.formGroup.controls["to"].disable();
    console.log("accountNumberCasa", this.accountNumber);
    // this.submitForm();
  }
}
